module.exports = __webpack_public_path__ + "img/1.731b0b8e.jpg";